import { AfterContentChecked, AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import * as Leaflet from 'leaflet';
import { PortalService } from '../../../services/portal.service';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import shpjs from 'shpjs';

@Component({
    selector: 'mapa-component',
    templateUrl: 'mapa-component.html',
    styleUrls: ['./mapa-component.scss']
})

export class MapaComponent implements OnInit, AfterViewInit, AfterContentChecked {

    @ViewChild('mapa1', {static: false}) mapa1;
    @ViewChild('casosMunicipio', {static: false}) casosMunicipio;
    @ViewChild('casosIncidenciaUF', {static: false}) casosIncidenciaUF;
    @ViewChild('casosIncidenciaRegiao', {static: false}) casosIncidenciaRegiao;
    @ViewChild('obitosUF', {static: false}) obitosUF;
    @ViewChild('obitosMunicipio', {static: false}) obitosMunicipio;
    @ViewChild('obitosIncidenciaUF', {static: false}) obitosIncidenciaUF;
    @ViewChild('obitosIncidenciaRegiao', {static: false}) obitosIncidenciaRegiao;

    @ViewChild('elTitle', {static: false}) elTitle: ElementRef;

    @Input() classCSS: string;
    @Input() mapaId: any;
    @Input() listaTotal: any = [];
    @Input() listCidades: any = [];
    @Input() listCidadesRegiao: any = [];
    @Input() titulo: string;

    @Input() isFilter = false;
    @Input() filter: any = 'qtd_confirmado';
    @Input() label: any = 'Casos confirmados';
    @Input() listColorRange: any = [];
    @Input() listRange: any = [];

    mapLoading = true;
    mapa: any;
    data: any;
    geral: any = {};
    geojson: any;
    mapaId2 = 'mapa2';
    filterMapa2 = 'qtd_obito';

    constructor(private portal: PortalService,
                private http: HttpClient) {
    }

    ngOnInit() {
        console.log('ngOnInit -> MapaComponent');
        this.listColorRange = this.getColorRange(this.filter);
    }

    ngAfterContentChecked() {
        // if (this.elTitle) {
        //     const element = this.elTitle.nativeElement;
        //     if ((element.clientWidth <= 370 && (element.classList.value.split(' ').indexOf('dp-flex') <= 0))) {
        //         element.classList.value += ' dp-flex';
        //     } else if (element.clientWidth >= 371 && element.classList.value.split(' ').indexOf('dp-flex') >= 1) {
        //         element.classList.value = element.classList.value.replace('dp-flex', ' ');
        //     }
        // }
    }

    async ngAfterViewInit() {
        if (this.mapaId === 'casosMunicipio' || this.mapaId === 'obitosMunicipio') {
            const geral = await this.portal.getCDN('PortalGeral');
            this.geral = geral[0];
            this.loadMapRadiusCircles();
        } else {
            this.loadmap();
        }
    }

    selectFilter(filter) {
        if (filter !== this.filter) {
            this.filter = filter;
            this.listColorRange = this.getColorRange(filter);

            if (filter === 'obitosAcumulado' || filter === 'incidenciaObito') {
                this.label = 'Óbitos';
                // this.titulo = 'Óbitos no Brasil';
            } else {
                this.label = 'Casos confirmados';
                // this.titulo = 'Casos e óbitos de COVID-19 por UF de notificação';
            }

            this.mapa.remove();
            this.mapa = null;
            this.mapLoading = true;
            this.loadmap();
        }
    }

    async loadMapRadiusCircles() {
        this.mapa = Leaflet.map(this.mapaId, await this.getOptionMap());
        this.mapLoading = false;

        this.data = await this.http.get('./assets/data/br-states.json').toPromise();
        Leaflet.geoJSON(this.data, 
            { style: (feature) => {
                return {
                    weight: 2,
                    color: 'white',
                    fillOpacity: 0,
                };
            }, onEachFeature: (feature, layer) => { }}
        ).addTo(this.mapa);
        await this.loadLocations2();

    }

    async loadLocations2() {
        const totalConfirmados = parseInt(this.geral.total_confirmado.replace('.', ''));
        //this.listCidades = await this.portal.getCDN('PortalMapa');
        

        let dataLocation:any  = await this.http.get('./assets/data/municipios.json').toPromise();
        let colorLegend = '';
        if (this.mapaId === 'casosMunicipio') {
            colorLegend = '#1DA584';
        } else {
            colorLegend = '#9A36BB';
        }
        this.listCidades.forEach((cidade: any) => {
            let colorCircle = '';
            let label = '';
            let info = 'casos';
            if (this.mapaId === 'casosMunicipio') {
                colorCircle = '#1DA584';
                label = 'casosAcumulado';
            } else {
                colorCircle = '#9A36BB';
                label = 'obitosAcumulado';

                info = 'óbitos';
            }
            if (cidade[label] != 0) {
                let radioValue = 1;
                if (cidade[label]>1){ 
                    radioValue = 1000
                }
                if (cidade[label]>100){ 
                    radioValue = 20000
                }
                if (cidade[label]>1000){ 
                    radioValue = 50000
                }
                let cord:any = dataLocation.filter(function(item) {
                    return item.codigo_ibge.toString().includes(cidade.cod);
                })[0];
                let circle: any = Leaflet.circle([cord.latitude, cord.longitude], {
                    color: 'rgba(255, 255, 255, 0)',
                    fillColor: colorCircle,
                    fillOpacity: 1,  // calcula decimal,
                    radius: radioValue // calcula percentual
                }).addTo(this.mapa);
                let myZoom = {
                    start: 4,
                    end: 4,
                    valor: 2
                };
                
                circle.on('click', ((evt: any) => {
                    console.log('lat/lon: ' + evt.latlng);
                }));
                var prevZoom = this.mapa.getZoom();
                var self = this;
                this.mapa.on('zoomend', function(e) {
                    var currZoom = self.mapa.getZoom();
                        var diff = prevZoom - currZoom;
                    if (diff == 0) {
                        circle.setRadius(radioValue)
                    }
                    if (diff < 0) {
                        if (radioValue > 50000) {
                            circle.setRadius(radioValue/Math.abs(diff)+8);
                        } else if (radioValue > 20000) {
                            circle.setRadius(radioValue/Math.abs(diff)+6);
                        } else {
                            circle.setRadius(radioValue/Math.abs(diff)+1);
                        }
                        if (circle.getRadius() < 1000) {
                            circle.setRadius(radioValue+1000);
                        }
                    } else if (diff > 0) {
                        if (radioValue > 50000) {
                            circle.setRadius(radioValue*Math.abs(diff)+8);
                        } else if (radioValue > 20000) {
                            circle.setRadius(radioValue*Math.abs(diff)+6);
                        } else {
                            circle.setRadius(radioValue*Math.abs(diff)+1);
                        }
                        if (circle.getRadius() < 1000) {
                            circle.setRadius(radioValue+1000);
                        }
                    }
                });
                
                const customOptions = {className: 'custom'};
                circle.bindPopup('<b>' + cidade.nome + '</b><br>' + cidade[label] + ' ' + info,
                    customOptions)/*.openPopup()*/;
            }
        });
        const legend = new Leaflet.Control({position: 'bottomright'});
        const thi$: this = this;
        legend.onAdd = map => {
            // @ts-ignore
            const div = Leaflet.DomUtil.create('div', 'info legend'),
                grades = [],
                labels = [];
            // from, to;{
                labels.push('<i style="background:' + colorLegend + '; border-radius:50%;width:3px;height:3px;margin:6px"></i> 1 - 100');
                labels.push('<i style="background:' + colorLegend + ';border-radius:50%;width:6px;height:6px;margin:4px"></i> 100 - 1000');
                labels.push('<i style="background:' + colorLegend + ';border-radius:50%;width:15px;height:15px;"></i>1000+');


            div.innerHTML = labels.join('<br>');
            return div;
        };

        legend.addTo(this.mapa);
    }

    async getOptionMap() {
        const southWest = new Leaflet.LatLng(-35.23150200, -72.89648000);
        const northEast = new Leaflet.LatLng(5.284280, -28.634110);
        const bounds = new Leaflet.LatLngBounds(southWest, northEast);

        return {
            zoom: 3.5,
            zoomControl: true,
            // attributionControl: true,
            layers: [
                Leaflet.tileLayer('',
                    {
                        minZoom: 3.4,
                        maxZoom: 12,
                        attribution: 'Open Street Map',
                    }
                )
            ],
            center: bounds.getCenter(),
            maxBounds: bounds
        };
    }

    async loadmap() {
        this.mapa = Leaflet.map(this.mapaId, await this.getOptionMap());
        this.mapLoading = false;
        await this.loadLocations(this.mapa, this.filter);
    }

    async loadLocations(mapa, filter) {
        this.filter = filter;
        this.mapa = mapa;
        localStorage.setItem('values_' + this.mapaId, JSON.stringify(this.listCidades));
        localStorage.setItem('filter_' + this.mapaId, this.filter);
        localStorage.setItem('range_' + this.mapaId, JSON.stringify(this.listColorRange));
        localStorage.setItem('label_' + this.mapaId, this.label);

        this.data = await this.http.get('./assets/data/br-states.json').toPromise();
        this.geojson = await shpjs('./assets/data/shp_regiao.zip');
        this.loadData();
    }

    async loadData() {
        const id = this.mapaId;

        function style(feature) {
            function getColor(d) {
                const values = JSON.parse(localStorage.getItem('values_' + id));
                const filter = localStorage.getItem('filter_' + id);
                const range = JSON.parse(localStorage.getItem('range_' + id));
                let state = {};
                if (d.properties && d.properties.sigla) {
                    state = _.find(values, {nome: d.properties.sigla});
                }
                if (d.properties && d.properties['Primary ID']) {
                    state = _.find(values, {cod: d.properties['Primary ID']});
                }

                if (state) {
                    let value = state[filter];
                    if (typeof value === 'string') {
                        value = parseFloat(state[filter].replace(',', '.'));
                    }
                    const resultRange = _.find(range, (o, key) => {
                        if (range[key + 1]) {
                            return value <= range[key + 1].range;
                        } else {
                            return value >= o.range;
                        }
                    });
                    if (resultRange && resultRange.color) {
                        return resultRange.color;
                    }
                }
            }

            return {
                weight: 2,
                opacity: 1,
                color: 'white',
                dashArray: '',
                fillOpacity: 0.7,
                fillColor: getColor(feature),
            };
        }
        

        if (this.mapaId !== 'casosIncidenciaRegiao' && this.mapaId !== 'obitosIncidenciaRegiao') {
            Leaflet.geoJSON(this.data, {
                style, onEachFeature: (feature, layer) => {
                    const customOptions = {className: 'custom'};
                    const values = JSON.parse(localStorage.getItem('values_' + id));
                    let label = localStorage.getItem('label_' + id);
                    const filter = localStorage.getItem('filter_' + id);
                    const state = _.find(values, {nome: feature.properties.sigla});
                    let value = '0';
                    if (state && state[filter]) {
                        value = state[filter];
                    }
                    function getValue(n) {
                        let r = '';
                        let x = 0;
    
                        for (let i = n.length; i > 0; i--) {
                            r += n.substr(i - 1, 1) + (x === 2 && i !== 1 ? '.' : '');
                            x = x === 2 ? 0 : x + 1;
                        }
                        return  r.split('').reverse().join('');
                    }
                    const n = value.toString();
                    let r = '';
                    let x = 0;

                    for (let i = n.length; i > 0; i--) {
                        r += n.substr(i - 1, 1) + (x === 2 && i !== 1 ? '.' : '');
                        x = x === 2 ? 0 : x + 1;
                    }

                    let custom = '';
                    if ((this.mapaId === 'obitosUF')) {
                        label = 'Óbitos';
                        custom = '<br>';
                        let regiao = _.find(this.listCidadesRegiao, {_id: feature.properties.sigla});
                        custom += 'Interior:&nbsp;<span>'+ getValue(regiao.interior.obitosAcumulado.toString())+'</span><br>';
                        if((regiao.metropolitana && regiao.metropolitana.obitosAcumulado))
                            custom += 'Região Metropolitana:&nbsp;<span>'+ getValue(regiao.metropolitana.obitosAcumulado.toString())+'</span><br>';
                    }
                    if ((this.mapaId === 'mapa1')) {
                        let regiao = _.find(this.listCidadesRegiao, {_id: feature.properties.sigla});
                        custom = '<br>';
                        custom += 'Interior:&nbsp;<span>'+ getValue(regiao.interior.casosAcumulado.toString())+'</span><br>';
                        if((regiao.metropolitana && regiao.metropolitana.casosAcumulado))
                            custom += 'Região Metropolitana:&nbsp;<span>'+ getValue(regiao.metropolitana.casosAcumulado.toString())+'</span><br>';
                    }
                    value = r.split('').reverse().join('');
                    layer.bindPopup('<b>' + feature.properties.name + '</b><br>' + label + ': ' + '<span>' + value + '</span>'/*+custom*/, customOptions);


                    if ((this.mapaId === 'obitosIncidenciaUF' || this.mapaId === 'casosIncidenciaUF')) {
                        value = r.split('').reverse().join('');
                        layer.bindPopup('<b>' + feature.properties.name + '</b><br>' + '<span>' + value.replace('.','') + '</span>', customOptions);
                    }
                },
            }).addTo(this.mapa);
        } else {


            Leaflet.geoJSON(this.geojson, {
                style, onEachFeature: (feature, layer) => {
                    const customOptions = {className: 'custom'};
                    const values = JSON.parse(localStorage.getItem('values_' + id));
                    const label = localStorage.getItem('label_' + id);
                    const filter = localStorage.getItem('filter_' + id);

                    const state = _.find(values, {cod: feature.properties['Primary ID']});
                    let value = '0';
                    if (state && state[filter]) {
                        value = state[filter];
                    }

                    const n = value.toString();
                    let r = '';
                    let x = 0;

                    for (let i = n.length; i > 0; i--) {
                        r += n.substr(i - 1, 1) + (x === 2 && i !== 1 ? '.' : '');
                        x = x === 2 ? 0 : x + 1;
                    }

                    if (this.mapaId === 'obitosIncidenciaRegiao') {
                        value = r.split('').reverse().join('');
                        layer.bindPopup('<b>' + feature.properties.Secondary + '</b><br>' + '<span>' + value + '</span>', customOptions);
                    } else {
                        value = r.split('').reverse().join('');
                        layer.bindPopup('<b>' + feature.properties.Secondary + '</b><br>' + label + ':' + '<span>' + value + '</span>', customOptions);
                    }

                },
            }).addTo(this.mapa);

            Leaflet.geoJSON(this.data, 
                { style: (feature) => {
                    return {
                        weight: 2,
                        color: '#CCC',
                        fillOpacity: 0,
                    };
                }, onEachFeature: (feature, layer) => { }}
            ).addTo(this.mapa);
        }

        const legend = new Leaflet.Control({position: 'bottomright'});
        const thi$: this = this;
        legend.onAdd = map => {
            // @ts-ignore
            const div = Leaflet.DomUtil.create('div', 'info legend'),
                grades = [],
                labels = [];
            // from, to;

            thi$.listColorRange.forEach((element, key) => {
                let next = '+';
                if (thi$.listColorRange[key + 1]) {
                    next = '&ndash;' + thi$.listColorRange[key + 1].range;
                    if (this.mapaId == 'obitosIncidenciaUF'){
                        next = '&ndash;' + (thi$.listColorRange[key + 1].range - 0.1).toString().replace('.', ',');
                    }
                }
                labels.push(
                    '<i style="background:' + element.color + '"></i> ' +
                    element.range + next);
            });


            div.innerHTML = labels.join('<br>');
            return div;
        };

        legend.addTo(this.mapa);
    }

    getColorRange(id) {
        let rangeDefault = [
            {
                color: '#D2E9E4',
                range: 0
            },
            {
                color: '#A6E9D9',
                range: 500
            },
            {
                color: '#7FD2BE',
                range: 1000
            },
            {
                color: '#51BDA2',
                range: 1500
            },
            {
                color: '#29B291',
                range: 2000
            },
            {
                color: '#1DA584',
                range: 5000
            },
            {
                color: '#145d45',
                range: 10000
            }];
        let rangeDefaultSmall = [
            {
                color: '#D2E9E4',
                range: 0
            },
            {
                color: '#A6E9D9',
                range: 10
            },
            {
                color: '#7FD2BE',
                range: 20
            },
            {
                color: '#51BDA2',
                range: 50
            },
            {
                color: '#29B291',
                range: 200
            },
            {
                color: '#1DA584',
                range: 500
            },
            {
                color: '#145d45',
                range: 1000
            }];
        let rangeDefaultObito = [
            {
                color: '#f8ddff',
                range: 0
            },
            {
                color: '#EBD3F2',
                range: 10
            },
            {
                color: '#D8ACE7',
                range: 20
            },
            {
                color: '#C684DC',
                range: 50
            },
            {
                color: '#B35DD0',
                range: 200
            },
            {
                color: '#A038C2',
                range: 500
            },
            {
                color: '#792A93',
                range: 1000
            }];

            if (this.mapaId == 'obitosIncidenciaUF') {
                rangeDefaultObito = [
                    {
                        color: '#f8ddff',
                        range: 0
                    },
                    {
                        color: '#EBD3F2',
                        range: 1
                    },
                    {
                        color: '#D8ACE7',
                        range: 5
                    },
                    {
                        color: '#C684DC',
                        range: 10
                    },
                    {
                        color: '#B35DD0',
                        range: 15
                    },
                    {
                        color: '#A038C2',
                        range: 20
                    }]
            }
        const rangeColors = {
            leitos_alocados: this.listRange,
            alcool_etilico: this.listRange,
            luava_proc_n_cirurgico: this.listRange,
            uti_adulto: this.listRange,
            avental: this.listRange,
            oculos_protecao: this.listRange,
            mascara_3_camadas: this.listRange,
            teste_rapido: this.listRange,
            sapatilha_toucas: this.listRange,
            casosAcumulado: rangeDefault,
            incidencia: rangeDefaultSmall,
            obitosAcumulado: rangeDefaultObito,
            incidenciaObito: rangeDefaultObito,
            qtd_confirmado: rangeDefault,
            qtd_obito: rangeDefaultObito
        };

        return rangeColors[id];
    }
}
